import Vue from "vue";

import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import InformacoesAdicionaisRepresentanteModel from "@/models/informacoesAdicionaisRepresentanteModel";
import informacoesAdicionaisRepresentanteService from "@/services/informacoesAdicionaisRepresentanteService";
import Delay from "@/utils/common/delay";

@Component({
    components: {
        gridComponent,
        shortcutComponent,
    },
})
export default class InformacoesAdicionaisRepresentanteListComponent extends Vue {
    private shortCutComponent: ShortcutComponent = null;

    data: InformacoesAdicionaisRepresentanteModel[] = [];

    private get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("dataCriacao", this.$t("__.ts.data"), GridColumnType.DateTime),
            new GridColumn("usuarioCriacaoNome", this.$t("__.ts.usuario"), GridColumnType.String),
            new GridColumn("texto", this.$t("__.ts.descricao"), GridColumnType.String),
        ];
    }

    public async show(registroId: number, tipoCadastro: number) {
        this.data = await informacoesAdicionaisRepresentanteService
            .getList(registroId, tipoCadastro)
            .withLoading()
            .resolveWithJSON<InformacoesAdicionaisRepresentanteModel[]>();

        while (!this.$refs.shortCutComponent) await Delay(100);
        this.shortCutComponent = this.$refs.shortCutComponent as ShortcutComponent;
        this.shortCutComponent.title = this.$t("__.ts.informacoesAdicionaisRepresentante") as string;

        this.shortCutComponent.show();
    }
}
